module.exports = __webpack_public_path__ + "static/media/road-E.a322c6cf.svg";